"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EngineerUtilizationHandle = void 0;
class EngineerUtilizationHandle {
    constructor(utilization) {
        this.utilization = utilization;
    }
    getNewCapacityDate(now = new Date()) {
        return this.utilization.reduce((previous, current) => {
            const currentDate = new Date(current?.year || 0, current?.month || 0, current?.day || 1);
            return previous.getTime() > currentDate.getTime()
                ? previous
                : new Date(currentDate.getFullYear(), currentDate.getMonth() + 1);
        }, new Date(now.getFullYear(), now.getMonth() + 1));
    }
    withNewCapacity(capacity) {
        const newItems = JSON.parse(JSON.stringify(this.utilization));
        newItems.push(capacity);
        const handle = new EngineerUtilizationHandle(newItems);
        return handle.withSortedUtilization();
    }
    withSortedUtilization() {
        const newItems = this.utilization
            .concat([])
            .sort((a, b) => new Date(a.year || 0, a.month || 0, a.day || 0).getTime() -
            new Date(b.year || 0, b.month || 0, b.day || 0).getTime());
        return new EngineerUtilizationHandle(newItems);
    }
}
exports.EngineerUtilizationHandle = EngineerUtilizationHandle;
//# sourceMappingURL=EngineerUtilizationHandle.js.map